export default "__VITE_ASSET__Bwj3nymX__"